import React from "react";

//GUI
import Menu from "../Icons/Menu";

//TS
import { Group, Scene, TourData } from "../../Types";
import { useCurrentSceneStore, useViewerStore } from "../../api/Zustand.ts";
import DownloadProgressBar from "../common/DownloadProgressBar.tsx";
import { useVolumeStore } from "../../state management/zustand/common-stores.ts";
import { create } from "zustand";
import { getLanguageFile } from "../common/GetLanguageFile.ts";
import {
  useEscapeRoomDataStore,
  useMockEscapeRoomStore,
} from "./escape-room/zustand.ts";
import { navigateWithLocksCheck } from "./TourViewerHotspots/exp-spots/ViewerWaypoint.tsx";

const goToFirstScene = (id: number) => {
  const setCurrentSceneID = useCurrentSceneStore.getState().setCurrentSceneID;

  return setCurrentSceneID(id);
};

function TourViewerHeader(props: { tourData: any }) {
  const { tourData } = props;

  const { toggleOpen } = useSidePanelStore();

  const { currentSceneID } = useCurrentSceneStore();

  const { viewer } = useViewerStore();

  const { type: escapeRoomType } = useEscapeRoomDataStore();

  const currentScene: Scene = React.useMemo(() => {
    return tourData.scenes.find((one: Scene) => one.id === currentSceneID);
  }, [tourData, currentSceneID]);

  // React.useEffect(() => {
  //   if (!viewer) goToFirstScene(tourData.startingScene);
  // }, [tourData.startingScene, viewer]);

  return (
    <>
      <div
        className="header"
        id={
          tourData.groups.find((one: any) =>
            one.scenes.some((scn: number | string) => scn === currentSceneID)
          )
            ? undefined
            : "no-group"
        }
        style={{
          color: tourData.groups.find((one: any) =>
            one.scenes.some((scn: number | string) => scn === currentSceneID)
          )?.textColor,

          background: tourData.groups.find((one: any) =>
            one.scenes.some((scn: number | string) => scn === currentSceneID)
          )?.mainColor,
        }}
      >
        <div>
          {tourData.groups.find((one: any) =>
            one.scenes.some((scn: number) => scn === currentSceneID)
          ) ? (
            <>
              <b>
                {
                  tourData.groups.find((one: any) =>
                    one.scenes.some((scn: number) => scn === currentSceneID)
                  )?.name
                }
              </b>{" "}
              -{" "}
            </>
          ) : (
            <>
              <b>{tourData.title}</b> -{" "}
            </>
          )}

          {currentScene?.title}
        </div>
        <button className="menu-btn" onClick={() => toggleOpen()}>
          <Menu
            fill={
              tourData.groups.find((one: any) =>
                one.scenes.some(
                  (scn: number | string) => scn === currentSceneID
                )
              )?.textColor
            }
          />
        </button>
      </div>
      <DownloadProgressBar top={50} />
      <Sidebar tourData={tourData} />
    </>
  );
}

const Sidebar = (props: { tourData: TourData }) => {
  const [isOpen, setOpen] = React.useState<number | undefined>(undefined);

  const { tourData } = props;

  const { currentSceneID } = useCurrentSceneStore();

  const currentScene = React.useMemo(() => {
    return tourData.scenes.find((one) => one.id === currentSceneID);
  }, [tourData, currentSceneID]);

  React.useEffect(() => {
    if (currentScene?.group) {
      setOpen(currentScene?.group!);
    } else setOpen(-1);
  }, [currentSceneID, tourData.scenes, currentScene?.group]);

  const { volume, setVolume } = useVolumeStore();

  const volumeShouldBeDisplayed: boolean = React.useMemo(() => {
    const mergedHotspots = tourData.scenes
      .map((sc: Scene) => sc.hotspots.map((hs) => hs))
      .flat();
    const hasAudioHs = mergedHotspots.find((one) => one.type === "audio");

    const scenesWithAudio = tourData.scenes.find(
      (one) => one.audio !== undefined
    );

    return !!scenesWithAudio || !!hasAudioHs;
  }, [tourData]);

  const { type: escapeRoomType } = useEscapeRoomDataStore();

  const { isOpen: panelIsOpen } = useSidePanelStore();
  return (
    <div className={panelIsOpen ? "groups-panel open" : "groups-panel closed"}>
      {escapeRoomType === 0 && (
        <div>
          <h3
            id="title"
            onClick={() => {
              navigateWithLocksCheck(tourData.startingScene!);
              // setCurrentSceneID(tourData.startingScene!);
            }}
          >
            {tourData.title}
          </h3>
          {tourData.groups
            .filter((group: any) => group.scenes.length !== 0)
            .map((group: any, index: number) => (
              <SidebarGroup
                key={group.id}
                group={group}
                currentSceneID={currentSceneID}
                tourData={tourData}
                isOpen={isOpen}
                setOpen={setOpen}
              />
            ))}

          {tourData.scenes.find((scn: Scene) => scn.group === undefined) && (
            <div
              className={"side-menu-group "}
              id={
                tourData.scenes
                  .filter((scn: Scene) => scn.group === undefined)
                  .some((scn: Scene) => scn.id === currentSceneID)
                  ? "active"
                  : undefined
              }
              style={{ borderColor: "black" }}
            >
              <h3
                id={isOpen === -1 ? "active" : undefined}
                onClick={() => {
                  setOpen(-1);
                  // setOpenG(!isOpenG);
                }}
              >
                {getLanguageFile("right_panel.scenes_no_group")}
              </h3>
              <div
                className={
                  isOpen === -1 ? "scenes-map open" : "scenes-map closed"
                }
              >
                {tourData.scenes
                  .filter((scn: Scene) => scn.group === undefined)
                  .map((scn: Scene) => (
                    <SceneElem
                      key={scn.id}
                      scnId={scn.id as number}
                      tourData={tourData}
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
      )}

      <label
        style={{ visibility: volumeShouldBeDisplayed ? "visible" : "hidden" }}
      >
        Volume <b>{Math.floor(volume * 100)}</b>
        <input
          type="range"
          min={0}
          max={100}
          value={volume * 100}
          onChange={(e) => setVolume(e.target.valueAsNumber / 100)}
        />
      </label>
    </div>
  );
};

const SidebarGroup = (props: {
  group: Group;
  currentSceneID: number | undefined;
  tourData: TourData;
  isOpen: number | undefined;
  setOpen: React.Dispatch<React.SetStateAction<number | undefined>>;
}) => {
  const { setCurrentSceneID } = useCurrentSceneStore();

  const { hardLockQuestions, softLockQuestions } = useMockEscapeRoomStore();

  const { group, currentSceneID, tourData, isOpen, setOpen } = props;

  const isActive = React.useMemo(() => {
    if (!!group.scenes?.some((scn) => scn === currentSceneID)) return "active";
    else return undefined;
  }, [group.scenes, currentSceneID]);

  return (
    <div
      className={
        isOpen === group.id ? "side-menu-group open" : "side-menu-group closed"
      }
      id={isActive}
      key={group.id}
      border-color={group.mainColor}
      style={{ borderColor: group.mainColor }}
    >
      <h3
        onClick={() => {
          setOpen(group.id);
        }}
        id={isActive}
      >
        {group.name}
      </h3>

      <div
        className={
          isOpen === group.id ? "scenes-map open" : "scenes-map closed"
        }
      >
        {group.scenes?.map((scn: number) => (
          <SceneElem key={scn} scnId={scn} tourData={tourData}></SceneElem>
        ))}
      </div>
    </div>
  );
};

const SceneElem = (props: { scnId: number; tourData: TourData }) => {
  const { currentSceneID } = useCurrentSceneStore();

  const thisScene = React.useMemo(() => {
    return props.tourData.scenes.find((one) => one.id === props.scnId);
  }, [props.scnId, props.tourData.scenes]);

  const thisSceneIsSelected = props.scnId === currentSceneID;

  return (
    <p
      style={{
        pointerEvents: thisSceneIsSelected ? "none" : "auto",
        fontWeight: thisSceneIsSelected ? 800 : 500,
      }}
      onClick={() => navigateWithLocksCheck(props.scnId)}
    >
      {thisScene?.title}
    </p>
  );
};

type sidePanelStoreType = {
  isOpen: boolean;
  setPanel: (bool: boolean) => void;
  openPanel: () => void;
  toggleOpen: () => void;
};

export const useSidePanelStore = create<sidePanelStoreType>()((set, get) => ({
  isOpen: false,
  setPanel: (bool: boolean) => set({ isOpen: bool }),
  openPanel: () => set({ isOpen: true }),
  toggleOpen: () => set({ isOpen: !get().isOpen }),
}));

export default TourViewerHeader;
